import React from 'react'
import "./floaters.css"
function Floater() {
  return (

    <div className="floaters points">
        <div className="point point-floating-1"></div>
        <div className="point point-floating-2"></div>
        <div className="point point-floating-3"></div>
        <div className="point point-floating-4"></div>
        <div className="point point-floating-5"></div>
        <div className="point point-floating-6"></div>
        <div className="point point-floating-7"></div>
        <div className="point point-floating-8"></div>
        <div className="point point-floating-9"></div>
</div>
  )
}

export default Floater